import { isFSA } from 'flux-standard-action'
import invariant from 'invariant'
import {
  REPORTS_TRANSACTIONS_SET_TRANSACTIONS,
  REPORTS_TRANSACTIONS_SET_TRANSACTION_DETAIL,
  REPORTS_TRANSACTIONS_SHOW_RESEND_EMAIL_MODAL,
  REPORTS_TRANSACTIONS_HIDE_RESEND_EMAIL_MODAL,
  REPORTS_TRANSACTIONS_SHOW_REFUND_BREAKDOWN_MODAL,
  REPORTS_TRANSACTIONS_HIDE_REFUND_BREAKDOWN_MODAL,
  REPORTS_TRANSACTIONS_SHOW_TRANSACTION_DETAIL_MODAL,
  REPORTS_TRANSACTIONS_HIDE_TRANSACTION_DETAIL_MODAL,
  REPORTS_TRANSACTIONS_HIDE_OLD_REFUND_MODAL,
  REPORTS_TRANSACTIONS_SHOW_OLD_REFUND_MODAL,
  REPORTS_TRANSACTIONS_REFUND_BREAKDOWN_SET_REFUND_ITEMS,
  REPORTS_TRANSACTIONS_REFUND_BREAKDOWN_SET_REFUND_ITEMS_PROMO,
  REPORTS_TRANSACTIONS_SET_OUTLETS,
  REPORTS_TRANSACTIONS_HIDE_SET_QUANTITY_MODAL,
  REPORTS_TRANSACTIONS_SHOW_SET_QUANTITY_MODAL
} from 'actions/reports/transactions/constants'
let initialState = {
  transactions: [],
  transactionDetail: null,
  netSales: 0,
  totalCollected: 0,
  totalTransactions: 0,
  openResendEmailModal: false,
  openRefundBreakdownModal: false,
  openTransactionDetailModal: false,
  openOldRefundModal: false,
  openSetQuantityModal: false,
  refundBreakdown: {
    refundItems: [],
    refundItemsPromo: []
  },
  outlets: []
}

function reducer (state = initialState, action) {
  invariant(
    isFSA(action),
    `Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ${JSON.stringify(action)}`
  )
  const {payload = {}} = action
  let {refundBreakdown} = state
  switch (action.type) {
    case REPORTS_TRANSACTIONS_SET_TRANSACTIONS:
      return {...state, ...payload.transactions}
    case REPORTS_TRANSACTIONS_SET_TRANSACTION_DETAIL:
      return {...state, transactionDetail: payload.transactionDetail}
    case REPORTS_TRANSACTIONS_SHOW_RESEND_EMAIL_MODAL:
      return {...state, openResendEmailModal: true}
    case REPORTS_TRANSACTIONS_HIDE_RESEND_EMAIL_MODAL:
      return {...state, openResendEmailModal: false}
    case REPORTS_TRANSACTIONS_SHOW_REFUND_BREAKDOWN_MODAL:
      return {...state, openRefundBreakdownModal: true}
    case REPORTS_TRANSACTIONS_HIDE_REFUND_BREAKDOWN_MODAL:
      return {...state, openRefundBreakdownModal: false}

    // set qty modal
    case REPORTS_TRANSACTIONS_SHOW_SET_QUANTITY_MODAL:
      return {...state, openSetQuantityModal: true}
    case REPORTS_TRANSACTIONS_HIDE_SET_QUANTITY_MODAL:
      return {...state, openSetQuantityModal: false}

    // transaction detail
    case REPORTS_TRANSACTIONS_SHOW_TRANSACTION_DETAIL_MODAL:
      return {...state, openTransactionDetailModal: true}
    case REPORTS_TRANSACTIONS_HIDE_TRANSACTION_DETAIL_MODAL:
      return {...state, openTransactionDetailModal: false}

    // old refund modal
    case REPORTS_TRANSACTIONS_SHOW_OLD_REFUND_MODAL:
      return {...state, openOldRefundModal: true}
    case REPORTS_TRANSACTIONS_HIDE_OLD_REFUND_MODAL:
      return {...state, openOldRefundModal: false}

    case REPORTS_TRANSACTIONS_REFUND_BREAKDOWN_SET_REFUND_ITEMS:
      refundBreakdown.refundItems = payload.items
      return {...state, refundBreakdown}

    case REPORTS_TRANSACTIONS_REFUND_BREAKDOWN_SET_REFUND_ITEMS_PROMO:
      refundBreakdown.refundItemsPromo = payload.itemsPromo
      return {...state, refundBreakdown}

    case REPORTS_TRANSACTIONS_SET_OUTLETS:
      return {...state, outlets: payload.outlets}

    default:
      return {...state}
  }
}

export {reducer}



// WEBPACK FOOTER //
// ./app/reducers/reports/transactions.js